export const STATE_NAMES = {
    PUBLISHERS: 'PUBLISHERS'
};
